<template>
  <div id="table-v1-256zqf">
    <div id="table-v1-cvd6h9"
      class="mb-0"
      v-if="showType == 'form-builder'"
      :style="properties.style"
    >
      <b-table id="table-v1-5i88na"
        class="custom-fb-table"
        striped
        responsive
        hover
        :items="items"
        :fields="fields"
      ></b-table>
    </div>
    <div id="table-v1-uvzqyn" v-if="showType == 'properties'">
      <table-v1-properties id="table-v1-qbq9dn" :formId="formId" />
    </div>
    <div id="table-v1-yphapv"
      style="font-size: 14px"      
      v-show="!computedHidden"
      v-if="(showType == 'form-submitter' && page == currentPage) || showType == 'e-form'"
      :style="computedPropertiesForm[this.id]?.style"
    >
      <b-table id="table-v1-vf7y92"
        style="font-size: 14px"
        class="custom-fb-table"
        striped
        responsive
        hover
        :items="items"
        :fields="fields"
      >
        <template #cell(signature)="data">
          <img id="table-v1-atno1w" style="width: 80px;" :src="data.value" />
        </template>
      </b-table>
    </div>
    <div id="table-v1-295ujg"
      v-if="showType == 'form-viewer'"
      :style="computedPropertiesForm[this.id]?.style"
    >
      <b-table id="table-v1-asfcsb"
        class="custom-fb-table mt-2"
        striped
        responsive
        hover
        :items="items"
        :fields="fields"
      ></b-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TableV1Properties from "./TableV1Properties.vue";
export default {
  name: "TableV1",
  components: { TableV1Properties },
  props: ["showType", "properties", "form", "id","formId", "page"],
  data() {
    return {
      computedProperties: ["hidden"],
      computedConditions: {}
    };
  },
  mounted() {
    this.computeConditions();
  },
  methods: {
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property] != null
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true)
        return "";

      return `
      <fieldset aria-describedby="" class="form-group is-table">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div tabindex="-1" role="group" class="bv-no-focus-ring">
          <table role="table" aria-busy="false" aria-colcount="3" class="table b-table form-builder-table table-striped table-responsive table-hover table-bordered">
            <thead role="rowgroup" class="">
              <tr role="row" class="">
                ${this.fields
                  .map(
                    (column, columnIndex) => `
                <th role="columnheader" scope="col" aria-colindex="${columnIndex +
                  1}" class="">
                  <div style="font-size: 14px">${column.label}</div>
                </th>
                `
                  )
                  .join("")}
              </tr>
            </thead>
            <tbody role="rowgroup">
              ${this.items
                .map(
                  item => `
              <tr role="row" class="">
              ${this.fields
                .map(
                  (column, columnIndex) => `
                <td aria-colindex="${columnIndex + 1}" role="cell" class="">
                  <div style="font-size: 14px">${item[column.key]}</div>
                </td>
                `
                )
                .join("")}
              </tr>
              `
                )
                .join("")}
            </tbody>
          </table>
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      },
      currentPage: state => state.form.currentPage
    }),
    fields() {
      const columns = this.computedPropertiesForm[`${this.id}_columns`] ?? [];
      return columns.map((column, columnIndex) => ({
        key: column.key,
        label: this.computedPropertiesForm[`${this.id}_columns_${columnIndex}`],
        class: column.class,
        sortable: false
      }));
    },
    items() {
      const items = this.computedPropertiesForm[`${this.id}_items`] ?? [];
      return items.map((item, itemIndex) => {
        const itemKeys = Object.keys(item);
        const newItems = {};
        for (let index = 0; index < itemKeys.length; index++) {
          const itemKey = itemKeys[index];
          newItems[itemKey] = this.computedPropertiesForm[`${this.id}_items_${itemIndex}_columns_${index}`];
        }
        return {
          isActive: true,
          ...newItems
        };
      });
    },
    computedHidden(){
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm[this.id].hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>

<style>
.custom-fb-table th,
.custom-fb-table td {
  padding: 5px !important;
  vertical-align: middle !important;
}
.custom-fb-table td {
  font-size: 12px;
  padding-left: 17px;
}
.custom-fb-table th {
  font-size: 14px;
  padding-left: 17px;
}
</style>
